/**
 * Purpose:
 * Computes dynamic CSS classes for ProtectedLayoutClient main element.
 *
 * Responsibility:
 * - Calculate main element classes based on menu state
 * - Handle transition classes based on mount state
 */

'use client';

import { protectedLayoutStyles } from '../ProtectedLayoutClient.styles';

export function useProtectedLayoutClasses(
  isMenuCollapsed: boolean,
  isMounted: boolean
) {
  const getMainClasses = () => {
    const baseClasses = protectedLayoutStyles.mainBase;

    // Use conditional padding based on collapsed state
    // Base padding (16rem/256px) when expanded, 4rem (64px) when collapsed
    const paddingClass = isMenuCollapsed
      ? protectedLayoutStyles.mainPaddingCollapsed
      : protectedLayoutStyles.mainPaddingExpanded;

    // Add transition only after mount to prevent layout shift
    const transitionClass = isMounted
      ? protectedLayoutStyles.mainTransition
      : '';

    return `${baseClasses} ${paddingClass} ${transitionClass}`.trim();
  };

  return { getMainClasses };
}

